import { defineComponent as _defineComponent } from 'vue'
import FooterButton from "@/components/shared/button/FooterButton.vue";
import { IAppPermission } from "@/domain/entities/serviceInfo/serviceInfo.types";
import { useServiceStore } from "@/stores/serviceStore";
import { PropType, computed } from "vue";


const __default__ = {
  name: "AppPermissionsModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  permissions: {
    type: Array as PropType<IAppPermission[]>,
    default: () => [],
  },
},
  emits: ["onClosedModal"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const serviceStore = useServiceStore();
const serviceInfo = computed(() => serviceStore.serviceInfo);

const requiredPermissions = computed(() =>
  props.permissions.filter((permission) => permission.required)
);
const optionPermissions = computed(() =>
  props.permissions.filter((permission) => !permission.required)
);

const closeAppPermissionsModal = () => {
  emit("onClosedModal");
};

const __returned__ = { props, emit, serviceStore, serviceInfo, requiredPermissions, optionPermissions, closeAppPermissionsModal, FooterButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})